"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  language: function language(state) {
    return state.app.language;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  sasToken: function sasToken(state) {
    return state.user.sasToken;
  },
  sasTokenExpiredTime: function sasTokenExpiredTime(state) {
    return state.user.sasTokenExpiredTime;
  },
  teamType: function teamType(state) {
    return state.user.teamType;
  },
  userInfo: function userInfo(state) {
    return state.user.userInfo;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  original_back_routes: function original_back_routes(state) {
    return state.permission.originBackRoutes;
  },
  functions: function functions(state) {
    return state.permission.functions;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  service_routes: function service_routes(state) {
    return state.permission.addRoutes;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  systemList: function systemList(state) {
    return state.user.systemList;
  },
  currentSysInfo: function currentSysInfo(state) {
    return state.user.currentSysInfo;
  },
  isAddRoute: function isAddRoute(state) {
    return state.nocache.isAddRoute;
  },
  isFullScreen: function isFullScreen(state) {
    return state.nocache.isFullScreen;
  },
  TRIP_STATUS: function TRIP_STATUS(state) {
    return state.nocache.TRIP_STATUS;
  },
  TRIP_TYPE: function TRIP_TYPE(state) {
    return state.nocache.TRIP_TYPE;
  },
  TRIP_CLASS: function TRIP_CLASS(state) {
    return state.nocache.TRIP_CLASS;
  },
  KIND_OF_CUSTOMER: function KIND_OF_CUSTOMER(state) {
    return state.nocache.KIND_OF_CUSTOMER;
  },
  SC_SYSTEM_LOGS_SUFFIX_MAPPING: function SC_SYSTEM_LOGS_SUFFIX_MAPPING(state) {
    return state.nocache.SC_SYSTEM_LOGS_SUFFIX_MAPPING;
  },
  getRegionData: function getRegionData(state) {
    return function (levelNum) {
      return state.baseData.regionData[levelNum] || [];
    };
  },
  regionData: function regionData(state) {
    return state.baseData.regionData['level_3'] || [];
  },
  homeType: function homeType(state) {
    return state.permission.homeType;
  }
};
var _default = exports.default = getters;